import React from 'react';
import { observer } from 'mobx-react-lite';
import { SearchInput } from './search-input';
import { useQueueStore } from '../context/use-queue-store';
import { ButtonProps } from '@cad-arc';

function QueueSearchInputBase({
    searchButtonVariant,
    onSetQueueFilterQuery,
}: {
    searchButtonVariant?: ButtonProps['variant'];
    onSetQueueFilterQuery?: (value: string) => void;
}): React.ReactElement {
    const store = useQueueStore();

    const handleChange = React.useCallback(
        (value: string) => {
            store.setFilterQuery(value);
            onSetQueueFilterQuery?.(value);
        },
        [onSetQueueFilterQuery, store]
    );

    return (
        <SearchInput
            initialValue={store.filterQuery || ''}
            onChange={handleChange}
            searchButtonVariant={searchButtonVariant}
        />
    );
}

export const QueueSearchInput = observer(QueueSearchInputBase);
